import React from 'react';
import { ITableColumn } from '../../Models/Table/ITableColumn';
import TableColumn from './TableColumn';

interface TableColumns {
	columns: ITableColumn[];
}

const TableColumns: React.FC<TableColumns> = ({ columns }) => {
	const columnsWidth = `calc((100%/${columns.length})`;

	return (
		<>
			{columns.map((column: ITableColumn, index: number) => {
				return (
					<TableColumn
						{...column}
						role='columnheader'
						key={index}
						style={{
							minWidth: column.minWidth ?? columnsWidth,
						}}
					/>
				);
			})}
		</>
	);
};

export default TableColumns;
